import { render, staticRenderFns } from "./section.vue?vue&type=template&id=ccbf8fa8&"
import script from "./section.vue?vue&type=script&lang=js&"
export * from "./section.vue?vue&type=script&lang=js&"
import style0 from "./section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/home/runner/work/myody_front/myody_front/components/link/Link.vue').default,SurveyQuestions: require('/home/runner/work/myody_front/myody_front/components/survey/SurveyQuestions.vue').default,Button: require('/home/runner/work/myody_front/myody_front/components/button/Button.vue').default,Card: require('/home/runner/work/myody_front/myody_front/components/card/Card.vue').default})
